<template>
  <v-text-field
    @input="handleVisitorName"
    :label="$t('appointment.formCreate.labels.visitorName')"
    :rules="rules"
    hide-details="auto"
    outlined
  />
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'VisitorName',

  props: {
    rules: {
      type: Array,
    },
  },

  methods: {
    ...mapMutations(['setAppointmentFields']),

    handleVisitorName(name) {
      this.setAppointmentFields({ visitor_name: name })
    },
  },
}
</script>
